import React from "react"
export function Return(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M2 15.01v1.74h16v-1.74H2zm.53-11.55a.978.978 0 00.217 1.537l11.041 6.318c.398.228.902.158 1.222-.17l1.223-1.254L4.515 3.185a1.64 1.64 0 00-1.985.276zm13.62 4.19l-1.792 1.164 1.868 1.069L18 8.079l-.8-.459a1.01 1.01 0 00-1.051.03zm-3.422-5.484l-4.64 3.06 2.67 1.528 3.98-4.076-.953-.545a1.01 1.01 0 00-1.057.033z"
        fill="currentColor"
        id="prefix__return"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
